const locales: {
  [key: string]: Record<string, string>;
} = {
  'zh-cn': {
    'DataGrid.changeTopRowSet.tooMuchFrozen': '冻结行数过多，无法正常预览',
    'DefaultContextMenuRender.copyRow': '复制行',
    'DefaultContextMenuRender.frozenRow': '冻结此行',
    'DefaultContextMenuRender.unFrozenAll': '解除全部冻结行',
    'DefaultContextMenuRender.newRow': '新增一行',
    'DefaultContextMenuRender.deleteRow': '删除',
    'DefaultContextMenuRender.upRow': '向上移动一行',
    'DefaultContextMenuRender.downRow': '向下移动一行',
    'HeaderCell.onDoubleClick.copyName': '复制列名成功',
    'SummaryCell.SelectColumnCell.unFrozen': '解冻',
    'headerCells.SortableHeaderCell.checkAll': '全选',
    'headerCells.SortableHeaderCell.cancelAll': '取消全选',
    'headerCells.SortableHeaderCell.cancel': '取消',
    'headerCells.SortableHeaderCell.ok': '确定',
    'headerCells.SortableHeaderCell.maxLimitText': '最大展示 200 条，超出部分已省略',
  },
  'en-us': {
    'DataGrid.changeTopRowSet.tooMuchFrozen': 'Too many frozen rows, unable to preview normally',
    'DefaultContextMenuRender.copyRow': 'Copy Row',
    'DefaultContextMenuRender.frozenRow': 'Freeze this row',
    'DefaultContextMenuRender.unFrozenAll': 'Unlock all frozen rows',
    'DefaultContextMenuRender.newRow': 'Add row',
    'DefaultContextMenuRender.deleteRow': 'Delete',
    'DefaultContextMenuRender.upRow': 'Move up one line',
    'DefaultContextMenuRender.downRow': 'Move down one line',
    'HeaderCell.onDoubleClick.copyName': 'The column name was copied successfully',
    'SummaryCell.SelectColumnCell.unFrozen': 'Unfreeze',
    'headerCells.SortableHeaderCell.checkAll': 'Select All',
    'headerCells.SortableHeaderCell.cancelAll': 'Cancel All Selection',
    'headerCells.SortableHeaderCell.cancel': 'Cancel',
    'headerCells.SortableHeaderCell.ok': 'OK',
    'headerCells.SortableHeaderCell.maxLimitText': 'Max display: 200 items',
  },
  'zh-tw': {
    'DataGrid.changeTopRowSet.tooMuchFrozen': '凍結行數過多，無法正常預覽',
    'DefaultContextMenuRender.copyRow': '複製行',
    'DefaultContextMenuRender.frozenRow': '凍結此行',
    'DefaultContextMenuRender.unFrozenAll': '解除全部凍結行',
    'DefaultContextMenuRender.newRow': '新增一行',
    'DefaultContextMenuRender.deleteRow': '刪除',
    'DefaultContextMenuRender.upRow': 'Move up one line',
    'DefaultContextMenuRender.downRow': 'Move down one line',
    'HeaderCell.onDoubleClick.copyName': '列名複製成功',
    'SummaryCell.SelectColumnCell.unFrozen': '解凍',
    'headerCells.SortableHeaderCell.checkAll': '全選',
    'headerCells.SortableHeaderCell.cancelAll': '取消所有選擇',
    'headerCells.SortableHeaderCell.cancel': '取消',
    'headerCells.SortableHeaderCell.ok': '確定',
    'headerCells.SortableHeaderCell.maxLimitText': '最大展示 200 條，超出部分已省略',
  },
};
export default locales;

function getLocale() {
  const isNavigatorLanguageValid =
    typeof navigator !== 'undefined' && typeof navigator.language === 'string';
  const browserLang = isNavigatorLanguageValid ? navigator.language.split('-').join('-') : '';
  return (
    window.localStorage.getItem('umi_locale')?.toLowerCase?.() ??
    browserLang?.toLowerCase() ??
    'en-us'
  );
}

export function formatMessage(key: string) {
  const locale = getLocale();
  const localText = locales[locale] || locales['en-us'];
  return localText?.[key];
}
